/**
 * Apply a pattern with placeholder replacement.
 *
 * @param {Object} data - The data object containing values
 * @param {string} pattern - Pattern with {placeholder} syntax, e.g. "{name}" or "{nome} {cognome}"
 * @param {*} fallback - Fallback value if no replacement is found (default: '')
 * @returns {string|*} The formatted string or fallback
 *
 * @example
 * applyPattern({ name: 'John Doe' }, '{name}', 'Unknown')
 * // Returns: 'John Doe'
 *
 * @example
 * applyPattern({ nome: 'John', cognome: 'Doe' }, '{nome} {cognome}', 'Unknown')
 * // Returns: 'John Doe'
 *
 * @example
 * applyPattern({}, '{name}', 'Unknown')
 * // Returns: 'Unknown'
 */
export function applyPattern(data, pattern, fallback = '') {
    if (!data || !pattern) return fallback

    let hasReplacement = false
    const result = pattern.replace(/\{(\w+)\}/g, (match, key) => {
        const value = data[key]
        if (value !== undefined && value !== null && value !== '') {
            hasReplacement = true
            return value
        }
        return ''
    }).trim()

    return (hasReplacement && result) ? result : fallback
}

/**
 * Extract cluster tags from various API response structures.
 * Handles both nested (tags.cluster) and flat (tags) structures.
 *
 * @param {Object} cluster - Cluster object from API
 * @returns {Object} Flat tags object
 */
export function getClusterTags(cluster) {
    if (!cluster?.tags) return {}
    // Handle nested structure: { tags: { cluster: { ... } } }
    if (cluster.tags.cluster) return cluster.tags.cluster
    // Handle flat structure: { tags: { ... } }
    return cluster.tags
}
